export default __webpack_public_path__ + "static/media/logo_white_new.bc62a89a.svg";